"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var _MuiList = _interopRequireDefault(require("../MuiList/MuiList"));

var _MuiListDropdown = _interopRequireDefault(require("../MuiListDropdown/MuiListDropdown"));

var MuiResponsiveDrawer = function MuiResponsiveDrawer(_ref) {
  var anchor = _ref.anchor,
      rootClass = _ref.rootClass,
      elevation = _ref.elevation,
      variant = _ref.variant,
      content = _ref.content,
      only = _ref.only;
  var components = {
    MuiList: _MuiList.default,
    MuiListDropdown: _MuiListDropdown.default
  };
  var width = '100%';
  if (anchor === 'left' || anchor === 'right') width = '32vw';

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    minWidth: width
  });

  return /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    only: only
  }, /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: styles.root,
    anchor: anchor,
    classes: {
      paper: styles.root
    },
    elevation: +elevation,
    variant: variant,
    open: true
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)(components, component, key);
  })));
};

var _default = MuiResponsiveDrawer;
exports.default = _default;
MuiResponsiveDrawer.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop array of: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
   * Hide the given breakpoint(s).
   * */
  only: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'bottom', 'left', 'right', 'top'
   * Side from which the drawer will appear.
   */
  anchor: function anchor(props, propName, componentName) {
    var validProps = ['bottom', 'left', 'right', 'top'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * number
   * The elevation of the drawer.
   * storyblok type is a number
   */
  elevation: _propTypes.default.string,

  /**
   * mui props: 'permanent', 'persistent', 'temporary'
   * The variant to use.
   */
  variant: function variant(props, propName, componentName) {
    var validProps = ['permanent', 'persistent', 'temporary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * components:
   * MuiList, MuiListDropdown
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiList', 'MuiListDropdown'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiResponsiveDrawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  variant: 'permanent',
  rootClass: [],
  content: [],
  only: []
};